import { QueryHookOptions, useQuery } from '@apollo/client';

import { PROJECT_BY_ID_QUERY } from '@frontend/app/queries';
import { ProjectByIdQuery, ProjectByIdQueryVariables } from '@frontend/app/queries/types/ProjectByIdQuery';
import { useApolloClientForAspirex } from '@frontend/applications/AffiliatesApp/hooks/useApolloClientForAspirex';

type IOptions = QueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables> & {
  isStaOffer?: boolean;
};

export const useProjectByIdQuery = (options: IOptions = {}) => {
  const { isStaOffer, ...queryOptions } = options;
  const aspirexClient = useApolloClientForAspirex();

  return useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(PROJECT_BY_ID_QUERY, {
    ...queryOptions,
    ...(isStaOffer && { client: aspirexClient }),
  });
};
